import type { Answer } from "./types";

// Answer types that should not be displayed to users
export const HIDDEN_ANSWER_TYPES: Answer["type"][] = [
  "Conditions",
  "Hidden Value",
  "Redirect",
  "Question Group",
] as const;
